/**
 * Platform Admin Hook (#670)
 *
 * Determines if the server has authorized the current platform administrator.
 * Used to gate platform-internal features like the monitoring pages.
 *
 * Platform admins are identified by the platformAdmin claim from auth-service
 * Backend APIs remain authoritative; this hook only controls client-side
 * navigation and sidebar visibility.
 */

import { isPlatformAdmin, useAuth } from '@agion/auth'

/**
 * Hook to check if the current user is a platform admin.
 * Returns loading state while auth is being validated.
 */
export function usePlatformAdmin() {
  const { user, isLoading, isAuthenticated } = useAuth()

  return {
    isPlatformAdmin: isAuthenticated && isPlatformAdmin(user),
    isLoading,
    user,
  }
}
